import { render, staticRenderFns } from "./CategoryRegister.vue?vue&type=template&id=4a3385fa"
import script from "./CategoryRegister.vue?vue&type=script&lang=js"
export * from "./CategoryRegister.vue?vue&type=script&lang=js"
import style0 from "./CategoryRegister.vue?vue&type=style&index=0&id=4a3385fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports